module.exports = "<div class=\"validation-requirement\" ng-class=\"{ 'validation-requirement--valid': !$ctrl.isInvalid }\"> <div class=\"validation-requirement__icon\"> <md-icon ng-if=\"$ctrl.isInvalid\"> clear </md-icon> <md-icon ng-if=\"!$ctrl.isInvalid\"> done </md-icon> </div> <div class=\"validation-requirement__text\"> {{ $ctrl.validationMessage }} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/validationRequirement/validationRequirement.html
// module id = 863
// module chunks = 0